import React from "react";
import { ColorTokenDetail } from "./ColorTokenDetail";
import JSONObjectNode from "./JSONObjectNode";
import JSONValueNode from "./JSONValueNode";
import { doesLeafNodeMatchFilter } from "./filterUtils";
import objType from "./objType";
import type { CommonInternalProps } from "./types";
interface Props extends CommonInternalProps {
    value: unknown;
}
export default function JSONNode({ keyPath, value, filterValue, ...rest }: Props) {
    const nodeType = objType(value);
    const simpleNodeProps = {
        keyPath,
        nodeType,
        value,
    };
    const nestedNodeProps = {
        ...rest,
        ...simpleNodeProps,
        data: value,
        filterValue,
    };
    const key = keyPath[0];
    switch (nodeType) {
        case "Object":
            return <JSONObjectNode key={key} {...nestedNodeProps}/>;
        case "String":
            // For leaf nodes, check if they match the filter
            if (!doesLeafNodeMatchFilter(filterValue || "", keyPath, String(value))) {
                return null; // Don't render if it doesn't match the filter
            }
            return <JSONValueNode key={key} {...simpleNodeProps} valueGetter={(raw: unknown) => <ColorTokenDetail cssCustomPropertyLabel={String(raw)} colorPath={`themeTokens.color.${keyPath.slice().reverse().join(".")}`}/>}/>;
        default:
            return <JSONValueNode key={key} {...simpleNodeProps} valueGetter={() => `<${nodeType}>`}/>;
    }
}
